import React from 'react'

export default function LoginPicture(props) {
  let { className, ...rest } = props

  if (typeof className !== 'undefined') {
    className += ' login-picture'
  } else {
    className = 'login-picture'
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="276"
      height="200"
      viewBox="0 0 276 200"
      {...rest}
      className={className}>
      <defs>
        <linearGradient
          id="prefix__linear-gradient"
          x1="-122.947"
          x2="-121.939"
          y1="-23.34"
          y2="-23.34"
          gradientUnits="objectBoundingBox">
          <stop offset="0" stopColor="#071786" />
          <stop offset=".151" stopColor="#05136b" />
          <stop offset=".324" stopColor="#031054" />
          <stop offset=".511" stopColor="#020d44" />
          <stop offset=".72" stopColor="#020c3b" />
          <stop offset="1" stopColor="#020c38" />
        </linearGradient>
        <style
          dangerouslySetInnerHTML={{
            __html:
              '.prefix__cls-2{fill:#0c2738}.prefix__cls-3{fill:#113952}.prefix__cls-4{fill:#d58066}.prefix__cls-7{fill:#719fbd}'
          }}></style>
      </defs>
      <g
        id="prefix__Group_224"
        data-name="Group 224"
        transform="translate(-822 -156)">
        <path
          id="prefix__Rectangle_396"
          d="M0 0H276V200H0z"
          data-name="Rectangle 396"
          transform="translate(822 156)"
          style={{ opacity: 0, fill: '#fff' }}
        />
        <g
          id="prefix__Group_219"
          data-name="Group 219"
          transform="translate(836 177)">
          <g
            id="prefix__Group_216"
            data-name="Group 216"
            transform="translate(0 20.485)">
            <path
              id="prefix__Path_190"
              d="M745.479 156.235c9.676 6.829 17.836 15.767 25.581 24.658 3.847 4.414 15.4 22.7 18.927 27.385 6.669 8.876 3.548 8.735-8.378 15.1a13.167 13.167 0 01-4.862 1.479c-20.023 2.037-29.27-24.2-35.286-38.314-2.613-6.127-5.436-13.7-7.659-19.98 1.732-11.192 11.677-10.328 11.677-10.328z"
              className="prefix__cls-2"
              data-name="Path 190"
              transform="translate(-658.649 -103.761)"
            />
            <path
              id="prefix__Path_191"
              d="M738.239 206.523c10.276-5.886 21.825-9.508 33.153-12.775 5.627-1.623 27.078-4.377 32.817-5.59 10.862-2.3 9.417.472 10.151 13.972a13.159 13.159 0 01-.713 5.031c-6.61 19.01-34.3 16.309-49.631 15.8-6.658-.22-14.714-.857-21.346-1.495-9.415-6.293-4.431-14.943-4.431-14.943z"
              className="prefix__cls-3"
              data-name="Path 191"
              transform="translate(-656.938 -86.63)"
            />
            <g
              id="prefix__Group_210"
              data-name="Group 210"
              transform="translate(34.347 52.314)">
              <path
                id="prefix__Path_192"
                d="M750.425 211.108a14.024 14.024 0 00-.479-3.009c-.059-.282-.465-3.008-.434-3.305.452-4.314 2.918-16.049 2.918-16.049l-11.825-1.863s.214 10.5-2.322 16.294h.014c-5.658 2.153-15.567 4.695-15.567 4.695s-10.82.2-11.41.358a9.889 9.889 0 00-3.8 1.56s-1.629 2.554 11.279 6.541c0 0 5.529 2.085 14.894 1.967l6.023.339c2.062.116 8.207.8 9.089.327a2.35 2.35 0 00.759-.609c1.343-1.711.829-5.189.861-7.246z"
                className="prefix__cls-4"
                data-name="Path 192"
                transform="translate(-707.456 -139.246)"
              />
              <path
                id="prefix__Path_193"
                d="M732.229 193.835c.144.674.259 1.357.349 2.043q.486-.911.94-1.84z"
                data-name="Path 193"
                transform="translate(-693.86 -135.43)"
                style={{ fill: '#ffd9b6' }}
              />
              <path
                id="prefix__Path_194"
                d="M749.947 201.565c-.034-.163-.184-1.145-.3-2-.488.18-.97.347-1.437.5-5.416 1.806-10.842.759-16.072-1.165-.1-.037-.191-.077-.28-.119-4.653 1.406-9.127 2.552-9.127 2.552s-10.82.2-11.41.359a9.889 9.889 0 00-3.8 1.56s-1.628 2.554 11.279 6.541c0 0 5.529 2.085 14.894 1.967l6.023.339c2.062.116 8.207.8 9.089.327a2.35 2.35 0 00.759-.609c1.341-1.711.827-5.19.859-7.247a14.024 14.024 0 00-.477-3.005z"
                data-name="Path 194"
                transform="translate(-707.456 -132.713)"
              />
              <path
                id="prefix__Path_195"
                d="M742.552 156.2h-.1A10.211 10.211 0 00732 165.442c-1.256 13.1-3.03 32.495-4.036 43.558l12.185 2.311a231.945 231.945 0 008.156-33.487 178.95 178.95 0 001.807-18.024c.036-.92-1.478-2.5-1.43-3.513-2.482-.353-3.444-.003-6.13-.087z"
                className="prefix__cls-2"
                data-name="Path 195"
                transform="translate(-696.201 -156.126)"
              />
            </g>
            <path
              id="prefix__Path_196"
              d="M756.722 137.022l2.256 6.828-3.935 1.3z"
              className="prefix__cls-4"
              data-name="Path 196"
              transform="translate(-646.992 -114.297)"
            />
            <path
              id="prefix__Path_197"
              d="M763.827 144.239c.125 2.227.675 15.338.675 15.338 1.457 1.42 8.01 1.479 10.585-1.053a6.384 6.384 0 002.151-3.694l-2.246-19.038z"
              className="prefix__cls-4"
              data-name="Path 197"
              transform="translate(-642.17 -114.972)"
            />
            <path
              id="prefix__Path_198"
              d="M778.183 126.494l1.23 6.754 1.876 10.3.528 2.9c-5.771 11.765-16.649 13.785-20.488 10.294s-7.063-24.851-7.063-24.851z"
              className="prefix__cls-4"
              data-name="Path 198"
              transform="translate(-647.418 -120.075)"
            />
            <path
              id="prefix__Path_199"
              d="M780.51 158.824s-9.691-17.008-12.4-18.279-11.249 1.454-16.4-5.12c-5.088-6.49-2.593-10.253-.812-10.729s5.669 5.975 11.359 1.526c5.793-4.526 18.233-5.467 20.511-.754 0 0 7.843.2 6.953 10.946s-3.153 19.889-5.692 20.875z"
              className="prefix__cls-2"
              data-name="Path 199"
              transform="translate(-650.478 -122.35)"
            />
            <path
              id="prefix__Path_200"
              d="M766.658 133.918c2.844 1.952 3.2 8.184-1.721 12.007l-2.893-10.053a3.135 3.135 0 014.614-1.954z"
              className="prefix__cls-4"
              data-name="Path 200"
              transform="translate(-643.149 -116.254)"
            />
            <path
              id="prefix__Path_201"
              d="M781.418 148.453c-7.4.867-19.028 3.039-21.171 11.568a33.693 33.693 0 00-.166 13.991c.641 3.6 1.228 7.205 1.654 10.84.719 6.138 1.578 13.051-.1 19.108l-6.933 12.7s33.661 14.852 50.353-4.818c0 0-1.059-48.985-8.883-60.459-.951-1.4-3.339-2.018-4.834-2.388a27.61 27.61 0 00-9.92-.542z"
              className="prefix__cls-7"
              data-name="Path 201"
              transform="translate(-647.18 -108.141)"
            />
            <path
              id="prefix__Path_202"
              d="M785.85 151.384c-.951-1.4-3.339-2.018-4.834-2.388a26.648 26.648 0 00-7.515-.731V221.9c7.424-.6 15.177-2.921 21.231-10.057 0 0-1.059-48.985-8.882-60.459z"
              className="prefix__cls-7"
              data-name="Path 202"
              transform="translate(-636.861 -108.14)"
            />
            <g
              id="prefix__Group_214"
              data-name="Group 214"
              transform="translate(63.625 42.611)">
              <g id="prefix__Group_212" data-name="Group 212">
                <path
                  id="prefix__Path_203"
                  d="M732.69 160.384s.8 6.335 4.51 10.582 7.953 5.929 11.432 10.416c2.735 3.527 29.95 29.632 32.719 20.116a5.856 5.856 0 00-.578-3.776c-4.619-11.252-15.869-16.013-25.7-21.933l-3.731-2.5s-1.619-6.411-5.556-9.945z"
                  className="prefix__cls-4"
                  data-name="Path 203"
                  transform="translate(-722.885 -144.086)"
                />
                <path
                  id="prefix__Path_204"
                  d="M734.935 150.394l-8.181 9.254a1.575 1.575 0 00.124 2.21l16.615 15.042a1.573 1.573 0 002.223-.108l8.026-8.841a1.576 1.576 0 00-.088-2.206l-16.461-15.461a1.574 1.574 0 00-2.258.11z"
                  data-name="Path 204"
                  transform="translate(-726.359 -149.861)"
                  style={{ fill: '#1c5c85' }}
                />
                <g
                  id="prefix__Group_211"
                  data-name="Group 211"
                  transform="translate(2.027 2.036)">
                  <path
                    id="prefix__Path_205"
                    d="M727.668 159.946l14.17 12.874 7.6-8.367-14.019-13.277z"
                    className="prefix__cls-7"
                    data-name="Path 205"
                    transform="translate(-727.668 -151.176)"
                  />
                </g>
                <path
                  id="prefix__Path_206"
                  d="M738.446 171.78s1.242-.754.731-3.112-1.6-7.925-1.6-7.925.016-1.989.8-1.552 2.489 1.668 3.147 5.122c0 0 .683 2.971 1.448 3.733a10.227 10.227 0 013.124 6.119s-5.596 1.888-7.65-2.385z"
                  className="prefix__cls-4"
                  data-name="Path 206"
                  transform="translate(-720.2 -144.775)"
                />
              </g>
              <g
                id="prefix__Group_213"
                data-name="Group 213"
                transform="translate(49.131 13.475)">
                <path
                  id="prefix__Path_207"
                  d="M768.584 202.36c1.145-1.53 1.312-3.694 1.389-5.979.186-5.56.46-11.11.706-16.664.11-2.472.217-4.947.3-7.422.169-5.057.513-12.482-6.105-13.692-1.505-.276-3.459.836-4.4 1.866a6.641 6.641 0 00-1.406 3.059c-.57 2.571-.4 5.757-.525 7.989-.255 4.583-.427 9.18-.458 13.786-.02 2.96 0 5.924.155 8.893.132 2.444.05 5.531 1.171 7.815 1.2 2.439 4.151 2.806 6.344 2.181a5.119 5.119 0 002.829-1.832z"
                  className="prefix__cls-4"
                  data-name="Path 207"
                  transform="translate(-758.081 -158.561)"
                />
              </g>
              <path
                id="prefix__Path_208"
                d="M774.879 185.4c-.911-6.86.05-31.51-9.775-32.515-10.871-1.114-8.765 32.811-8.765 32.811z"
                className="prefix__cls-7"
                data-name="Path 208"
                transform="translate(-709.996 -148.217)"
              />
            </g>
            <g
              id="prefix__Group_215"
              data-name="Group 215"
              transform="translate(0 96.465)">
              <path
                id="prefix__Path_209"
                d="M696 223.915a13.955 13.955 0 002.886-.982c.266-.107 2.885-.971 3.183-.991 4.327-.288 16.312.147 16.312.147l-.175-11.971s-10.315 2-16.452.483v.015c-3.084-5.21-9.782-12.312-9.782-12.312s-2.272-5.794-2.531-6.349 1.6-1.905.093-3.451c0 0-.293-8.014-2.024 5.384 0 0-3.146 5.554-1.437 14.762l.691 5.994c.235 2.051.606 8.223 1.224 9.013a2.333 2.333 0 00.729.644c1.914 1.031 5.255-.068 7.283-.386z"
                className="prefix__cls-4"
                data-name="Path 209"
                transform="translate(-685.123 -183.811)"
              />
              <path
                id="prefix__Path_210"
                d="M698.989 223.777a33.137 33.137 0 01-.2-9.01 18.389 18.389 0 011.615-6.025c-2.785-5.206-5.766-11.849-5.766-11.849s-2.113-7.611-2.371-8.165a9.922 9.922 0 00-2.184-3.477s-2.715-4.187-4.447 9.211c0 0-1.115 5.8.593 15.01l.691 5.994c.235 2.051.606 8.223 1.224 9.013a2.306 2.306 0 00.729.643c1.913 1.032 5.254-.068 7.286-.386a13.48 13.48 0 002.83-.959z"
                className="prefix__cls-2"
                data-name="Path 210"
                transform="translate(-685.28 -184.632)"
              />
              <path
                id="prefix__Path_211"
                d="M703.023 215.251c14.11 1.965 45.088 4.659 62.587-1.32 2.752-.94 5.7-3.736 6.01-6.761.239-2.337-.733-5.768-2.746-7.182-1.662-1.168-7.177-1.558-9.1-1.471-5.438.246-40.149 3.014-56.55 4.334z"
                className="prefix__cls-3"
                data-name="Path 211"
                transform="translate(-675.542 -177.018)"
              />
            </g>
          </g>
          <g
            id="prefix__Group_218"
            data-name="Group 218"
            transform="translate(142.042)">
            <path
              id="prefix__Path_212"
              d="M807.4 180.832a33.949 33.949 0 1140.121 0h14.807a44.448 44.448 0 10-69.735 0z"
              data-name="Path 212"
              transform="translate(-773.681 -109.124)"
              style={{ fill: '#1c5c85' }}
            />
            <g
              id="prefix__Group_217"
              data-name="Group 217"
              transform="translate(0 54.945)">
              <path
                id="prefix__Path_213"
                d="M876.457 144.6H783.7a6.71 6.71 0 00-6.711 6.71v87.89a6.711 6.711 0 006.711 6.714h92.757a6.712 6.712 0 006.711-6.714v-87.891a6.711 6.711 0 00-6.711-6.709zM837.3 191.149v25.344a3.408 3.408 0 01-3.407 3.409h-6.229a3.408 3.408 0 01-3.409-3.409v-25.344a13.451 13.451 0 01-7.1-11.807A13.771 13.771 0 01830.36 165.8a13.621 13.621 0 0114.04 13.62 13.457 13.457 0 01-7.1 11.729z"
                data-name="Path 213"
                transform="translate(-776.989 -144.599)"
                style={{ fill: '#2196f3' }}
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
